import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import type Contract from 'modules/contracts/lib/Contract'
import type ContractVersion from 'modules/contracts/store/models/ContractVersion'

import ContractVersionCard from './ContractVersionCard'
import { Milestone } from './Timeline/Milestone'

interface Props {
  contract: Contract
  contractContractVersions: ContractVersion[]
  allContractVersionsSorted: ContractVersion[]
  previousContract?: Contract
  highlightedItem?: ContractVersion
  setSelectedContractVersion: (item: ContractVersion | undefined) => void
}

interface ContractStartMilestoneProps {
  label?: string
}

const ContractEndMilestone = ({ label }: ContractStartMilestoneProps) => {
  return (
    <Milestone color="grey600" label={label}>
      <Box gap="s8">
        <Box flexDirection="row" gap="s8" alignItems="center">
          <Text.Normal weight="semibold" size="200" color="grey700">
            {i18n.t('contract_versions.navigator.timeline.terminated')}
          </Text.Normal>
        </Box>
      </Box>
    </Milestone>
  )
}

const ContractHistory = ({
  contract,
  contractContractVersions,
  allContractVersionsSorted,
  previousContract,
  highlightedItem,
  setSelectedContractVersion,
}: Props) => {
  const label = contract.hasEndDate() ? dateToString(contract.endsOn!, 'ui_dmy_long') : undefined
  return (
    <Box gap="s8">
      {contract.hasExpired() && <ContractEndMilestone label={label} />}
      {contractContractVersions.map((contractVersion, index) => (
        <ContractVersionCard
          key={contractVersion.id}
          contractVersionIndex={contractContractVersions.length - index}
          contractVersion={contractVersion}
          previousContract={previousContract}
          contractContractVersions={contractContractVersions}
          allContractVersionsSorted={allContractVersionsSorted}
          highlightedItem={highlightedItem}
          setSelectedContractVersion={setSelectedContractVersion}
        />
      ))}
    </Box>
  )
}

export default observer(ContractHistory)
